var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-nbhd-tips "},[_c('div',{staticClass:"c-nbhd-tips__inner | grid"},[_c('neighbourhood-tips-panel')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }